import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import DonorForm from './donor-form';
import { useUpdateOrganisationVerificationMutation } from '@/services/organisations/queries';
import { useAuthStore } from '@/store/auth';

export default function ExperiencePage(props: { organisationId: string }) {
  const navigate = useNavigate();
  const setUserOrganisationVerified = useAuthStore(state => state.setUserOrganisationVerified);
  const [showDonorForm, setShowDonorForm] = useState(false);  
  const { mutate: updateOrganisationVerification } = useUpdateOrganisationVerificationMutation(props.organisationId, () => {
    setUserOrganisationVerified(true);
    navigate('/verify/success');
  }, (error) => {
    console.error(error);
  });

  return (
    <div className='flex min-h-screen items-start justify-center bg-slate-50 p-4'>
      <div className='space-y-8'>
        <div className='space-y-2 italic'>
          <p className='text-base font-semibold leading-relaxed text-slate-600'>
            The information you are about to provide is only visible to the
            system owner (The Geospatial Insight Support Team) of the
            Foundation.
          </p>
          <p className='font-semibold leading-relaxed text-slate-600'>
            All information are optional and confidential.
          </p>
          <p className='font-semibold leading-relaxed text-slate-600'>
            These questions help the Foundation to verify the projects or
            capabilities of your organization.
          </p>
        </div>

        {!showDonorForm ? (
          <div className='pt-4'>
            <h2 className='mb-8 text-lg font-semibold text-slate-900 md:text-2xl'>
              Have you worked with a donor?
            </h2>

            <div className='flex flex-col gap-4 sm:flex-row'>
              <Button
                className='bg-[#283474] px-12 py-6 text-xl text-white hover:bg-[#1e2859]'
                size='lg'
                onClick={() => setShowDonorForm(true)}
              >
                Yes
              </Button>

              <Button
                className='bg-gray-100 px-12 py-6 text-xl text-slate-800 hover:bg-gray-200'
                variant='outline'
                size='lg'
                onClick={() => {
                  updateOrganisationVerification({ verified: true });
                }}
              >
                No
              </Button>
            </div>
          </div>
        ) : (
          <DonorForm />
        )}
      </div>
    </div>
  );
}
